translatedMessages = {
	aplicar: "Apply",
	cancelar: "Cancel",
	desde: "Since",
	hasta: "Until",
	custom: "Custom",
	do: "Su",
	lu: "Mo",
	ma: "Tu",
	mi: "We",
	ju: "Th",
	vi: "Fr",
	sa: "Sa",
	enero: "January",
	febrero: "February",
	marzo: "March",
	abril: "April",
	mayo: "May",
	junio: "June ",
	julio: "July ",
	agosto: "August",
	septimbre: "September",
	octubre: "October",
	novimbre: "November ",
	decimbre: "December",
	seleccione: "Select",
	reserva_de_dispositivo: "Hold asset",
	bloqueo_de_dispositivo: "Disable asset",
	agregado_de_dispositivo_a_propuesta: "Add asset to proposal",
	agregado_de_dispositivo_a_pauta: "Add asset to campaign",
	detalle_de_reserva: "HOLD DETAIL",
	motivo_de_bloque: "REASON FOR DISABILITY",
	campo_requerido: "Required field",
	la_fecha_de_expiracion_debe_ser_mayor_a_hoy:
		"Expiration date must be after today",
	la_fecha_de_inicio_no_puede_ser_menor_a_hoy:
		"The start date must be after today",
	la_fecha_de_inicio_no_puede_ser_mayor_a_la_fecha_de_fin:
		"The start date must be prior to the end date",
	guardado: "Save",
	el_dispositivo_fue_agregado_con_exito: "The asset was successfully added",
	descargar: "Download",
	listado_de_errores: "Error summary",
	soporte: "Asset",
	soportes: "Assets",
	detalle: "Details",
	los_datos_se_han_guardado_con_exito: "Data has been successfully saved",
	ha_ocurrido_un_error_al_guardar: "An error has occurred while saving data",
	arrastra_los_archivos_aqui_para_subirlos: "Drag & drop file",
	su_navegador_no_admite_la_carga_de_archivos_de_arrastrar_y_soltar:
		"Your browser does not support Drag & drop file.",
	utilice_el_siguiente_formulario_de_respaldo_para_cargar_sus_archivos_como_en_los_viejos_tiempos:
		"Please, use the backup form to upload your files.",
	el_archivo_es_demasiado_grande_filesize_tamano_maximo_de_archivo:
		"The file is too large ({{filesize}} MB) . Maximum file size: {{maxFilesize}} MB. ",
	no_puedes_subir_archivos_de_este_tipo:
		"It is not possible to upload this type of file.",
	el_servidor_respondio_con_el_codigo_statusCode:
		"Server response code {{statusCode}.",
	cancelar_carga: "Cancel uploading",
	estas_seguro_de_que_deseas_cancelar_esta_carga:
		"Are you sure to cancel file upload?",
	remover_archivo: "Remove file",
	no_puedes_subir_mas_archivos: "It is not possible to upload more files.",
	enero_: "January",
	febrero_: "February",
	marzo_: "March",
	abril_: "April",
	mayo_: "May",
	junio_: "June",
	julio_: "July",
	agosto_: "August",
	septiembre_: "September",
	octubre_: "October",
	noviembre_: "November",
	diciembre_: "December",
	dispositivo: "Asset",
	dispositivos: "Assets",
	no_se_han_reservado_dispositivos: "No assets on hold.",
	eliminado: "Remove",
	el_soporte_fue_eliminado_con_exito: "The asset was successfully removed",
	soporte_eliminado: "Asset removed",
	el_soporte_se_elimino_correctamente: "The asset was successfully removed",
	el_dispositivo_fue_eliminado_con_exito: "The asset was successfully removed",
	categorias_de_dispositivo: "CATEGORY OF ASSET",
	nombre_de_tipo_de_dispositivo: "TYPE OF ASSET",
	ver_detalle: "See detail",
	street_view_no_esta_disponible_antes_de_seleccionar_ubicacion_en_el_mapa:
		"Street view is not available before selecting location on the map",
	street_view_no_esta_disponible_para_el_lugar_seleccionado:
		"Street view is not available for selected location",
	no_se_han_activado_campanas_aun_con_este_dispositivo:
		"No campaigns have been activated with this asset yet.",
	los_datos_fueron_eliminados_con_exito: "The data was successfully removed",
	la_imagen_fue_subida_con_exito: "The image was successfully uploaded",
	la_imagen_fue_eliminada_con_exito: "The image was successfully removed",
	el_archivo_fue_eliminado_con_exito: "The file was successfully removed",
	los_datos_fueron_actualizados_con_exito: "The data was successfully uploaded",
	ha_ocurrido_un_error_al_eliminar_el_elemento:
		"An error has occurred while deleting an asset",
	no_hay_propuestas_creadas: "There are no proposals created.",
	agencia_creada_con_exito: "Agency created successfully",
	cuenta_creada_con_exito: "Account created successfully",
	error: "Error",
	direccion: "Address",
	fecha_inicio: "Start date",
	fecha_fin: "End date",
	cantidad: "Quantity",
	cuenta: "Account",
	agencia: "Agency",
	elementos_en_propuesta: "Assets added to a proposal",
	fecha_expiracion: "Expiration date",
	acciones: "Actions",
	dar_de_baja: "Remove",
	porciento_ocupacion: "% Occupancy",
	tooltip_porciento_ocupacion: "Occupation: [bold]{valueY}[/]",
	la_fecha_de_expiracion_debe_ser_menor_o_igual_a_la_fecha_de_inicio:
		"The expiration date must be less than or equal to the start date",
	ha_excedido_la_maxima_cantidad_total_de_elementos:
		"Has exceeded the maximum number of elements",
	enviar_aprobacion_de_propuesta: "Send proposal approval",
	enviar_cambios_en_propuesta: "Submit proposal changes",
	no_aplica: "Doesn’t apply",
	completar: "Complete",
	ayuda_soporte: "Asset assitance",
	no_hay_campannas_creadas: "No campaigns created.",
	disponible: "Available",
	no_disponible: "Not available",
	la_fecha_inicio_mayor_expiracion:
		"The start date must be greater than the expiration date",
	la_fecha_fin_mayor_inicio:
		"The end date must be greater than or equal the start date",
	datos_de_propuesta: "Proposal data",
	datos_de_campana: "Campaign data",
	elementos_en_campana: "Assets added to a campaign",
	listado_de_elementos_en_propuesta: "List of assets in proposal",
	listado_de_elementos_en_campana: "List of assets in campaign",
	titulo: "Title",
	contacto: "Contact",
	usuario_asignado: "Assigned user",
	tipo_gestion: "Action Type",
	cliente_prospect: "Client / Prospect",
	fecha: "Date",
	cliente: "Client",
	prospect: "Prospect",
	tipo_de_contacto: "Contact type",
	empresa: "Enterprise",
	gestion: "Action",
	estado: "Status",
	potencialidad: "Probability",
	crear_contacto: "Create contact",
	guardar: "Save",
	nombre: "Name",
	nombre_: "Name",
	apellido: "Last name",
	asignado_a: "Assigend to",
	nombre_de_agencia: "Agency name",
	rubro: "Bussiness area",
	categoria: "Category",
	cargo: "Position",
	sub_rubro: "Bussiness sub area",
	email_empresa: "Enterprise email",
	email: "Email",
	telefono_1: "phone 1",
	telefono_2: "phone 2",
	cumpleanios: "Birthday",
	genero: "Gender",
	estado_civil: "Civil status",
	tiene_hijos: "Has children",
	origen_de_contacto: "Contact origin",
	url_sitio_web_de_la_empresa: "Url enterprise website",
	observaciones: "Observations",
	ingrese_observaciones: "Write observations (optional)",
	proveedor: "Vendor",
	pais: "Country",
	ciudad: "City",
	crear_gestion: "Create action",
	no_hay_resultados: "No results",
	buscando: "Search...",
	para_buscar_ingrese_n_o_mas_caracteres:
		"To search enter 3 or more characters",
	masculino: "Male",
	femenino: "Female",
	si: "Yes",
	no: "No",
	nombre_de_cuenta: "Account name",
	nombre_de_provedor: "Vendor name",
	potencialidad_del_negocio: "Business potential",
	ejecutivo: "Executive",
	date_format: "dd/mm/yyyy",
	datepicker: {
		days: [
			"Sunday",
			"Monday",
			"Tuesday",
			"Wednesday",
			"Thursday",
			"Friday",
			"Saturday",
			"Domingo",
		],
		daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
		daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"],
		months: [
			"January",
			"February",
			"March",
			"April",
			"May",
			"June",
			"July",
			"August",
			"September",
			"October",
			"November",
			"December",
		],
		monthsShort: [
			"Jan",
			"Feb",
			"Mar",
			"Apr",
			"May",
			"Jun",
			"Jul",
			"Aug",
			"Sep",
			"Oct",
			"Nov",
			"Dec",
		],
		today: "Today",
		format: "dd/mm/yyyy",
		titleFormat: "MM yyyy",
	},
	tipo_de_gestion_realizada: "Type of executed action",
	titulo_de_la_gestion: "Action title",
	se_envio_obsequios: "Gifts sent",
	obsequio: "Gift",
	importe: "Amount",
	moneda: "Currency",
	la_gestion_fue_guardada_con_exito: "Action was successfully saved",
	eliminar_gestion: "Delete action",
	editar_gestion: "Edit action",
	eliminar: "Delete",
	esta_seguro_que_desea_eliminar_la_gestion_nombre_gestion:
		"Are you sure you want to delete this action(xxxxxx)?",
	faltan_datos_a_completar: "Missing data to complete",
	medidas_visibles_mayores_a_finales:
		"The visible measurements cannot be greater than the final ones",
	actualizado: "Update",
	telefono: "Phone",
	esta_seguro_que_desea_eliminar_al_contacto:
		"Are you sure you want to delete the contact xxxxxx",
	eliminar_contacto: "Delete contact",
	gestiones: "Actions",
	listado_de_gestiones: "List of actions",
	buscar: "Search",
	todos: "All",
	ninguno: "None",
	fecha_de_creacion_del_gestion: "Date action took place",
	logo: "Logo",
	tipo_de_empresa: "Company Types",
	eliminar_agencia: "Delete agency",
	eliminar_cuenta: "Delete account",
	eliminar_proveedor: "Delete provider",
	esta_seguro_que_desea_eliminar_la_empresa:
		"Are you sure you want to delete the company (xxxxxx)",
	contactos: "Contacts",
	listado_de_contactos: "Contacts directory",
	empresas: "Companies",
	listado_de_empresas: "Companies directory",
	crear_agencia: "Add agency",
	crear_cuenta: "Add account",
	editar_agencia: "Edit agency",
	crear_proveedor: "Add supplier ",
	tipo_de_proveedor: "Type of supplier",
	clasificacion: "Classification",
	sub_rublo: "Sub classification",
	soltar_imagenes_para_cargar_click_aqui: "Drag and drop or click here",
	soltar_imagenes_o_cargar: "Drag and drop or click here",
	eliminar_logo: "Delete logo",
	editar_cuenta: "Edit account",
	editar_proveedor: "Edit supplier",
	nuevos_contactos: "New contact",
	ultima_actualizacion: "Last update",
	gestion_realizada_a: "A sales action was carried out to ",
	los_datos_se_han_eliminado_con_exito: "Data has been successfully deleted",
	gestiones_historicas: "Historical management",
	gestiones_futuras: "Future management",
	email_personal: "Personal email",
	validar: "Validate",
	realizo_una_gestion_con: "carried out a management with",
	gestion_realizada_por: "Management carried out by",
	no_hay_gestiones_realizadas: "There are no steps taken",
	proveedores: "Providers",
	total_obsequios: "Total gifts",
	resumen_de_gestiones: "Summary of procedures",
	metricas_de_gestiones_comeriales: "Business management metrics",
	gestiones_totales: "Total management",
	reunion_prom_semana: "Average meeting week",
	propuestas_enviadas: "Proposals submitted",
	conversion_en_porcentaje: "Conversion to percentage",
	forma_de_contacto: "Contacted by",
	tipo_de_cliente: "Client type",
	modulo: "Module",
	nombre_completo: "Full name",
	mensaje: "Message",
	enviar: "Send",
	ultimos_contactos_gestionados: "Last managed contacts",
	listado_de_contactos: "List of contacts",
	ultimas_cuentas_trabajadas: "LAST ACCOUNTS WORKED",
	ultimos_contactos_trabajados: "LAST MANAGED CONTACTS",
	proximas_gestiones: "UPCOMING ACTIVITES",
	gestiones_pendientes_confirmacion: "PENDING CONFIRMATION",
	gestiones_historicas: "PAST ACTIVITIES",
	confirmar: "CONFIRM",
	confirmar_: "Confirm",
	editar: "Edit",
	no_cuentas_trabajadas: "There are no worked accounts",
	no_contactos_gestionados: "No activities in contacts",
	no_informado: "Uninformed",
	no_proximas_gestiones: "No upcoming activities",
	no_gestiones_pendientes_confirmacion: "No activities pending confirmation",
	no_gestiones_historicas: "No historical activities",
	historial: "HISTORY",
	propuestas_pendientes_respuesta: "PROPOSALS PENDING ANSWER",
	proximas_campannas: "NEXT CAMPAIGNS",
	no_hay_gestiones_futuras_cargadas: "No future activities loaded",
	no_hay_gestiones_historicas_cargadas: "No historical activities loaded",
	realizado_por: "Made by",
	propuesta: "Proposal",
	ver: "VIEW",
	campañas_realizadas: "Campaigns carried out",
	tasa_de_conversion: "Conversion rate",
	promedio_de_reuniones_semanales: "Average weekly meetings",
	gestiones_realizadas: "Activities carried out",
	no_hay_propuestas_pendientes_de_respuesta: "No proposals pending response",
	no_hay_proximas_campannas: "There are no upcoming campaigns",
	seguro_desea_confirmar_la_gestion:
		"¿You sure want to confirm the activity (xxxxxx)?",
	confirmar_gestion: "Confirm activity",
	el_numero_de_telefono_es_incorrecto: "The phone number is wrong",
	otro: "Other",
	tipos_de_empresas: "Types of companies",
	sin_contactos_asociados: "No associated contacts",
	sin_gestiones_asociadas: "No associated activity",
	ultima_gestion: "Last activity",
	no_hay_ultimos_contactos_gestionados: "No last contacts managed",
	no_hay_contactos: "No contacts",
	usuario: "User",
	tipo_de_gestion: "Type of activity",
	gestiones_por_usuario_top_15: "Activities per user (TOP 15)",
	montos_en_propuestas_generadas: "Amounts in generated proposals",
	montos_en_campanas_ejecutadas: "Amounts in campaigns executed",
	evolucion_de_las_gestiones: "Evolution of activities",
	gestiones_por_cuenta_top_20: "Activities per account (top 20)",
	crear_empresa: "Create company",
	campanas_generadas: "Generated campaigns",
	tasa_de_conversion: "Conversion rate",
	no_hay_empresas_creadas: "No companies created",
	no_hay_sucursales_creadas: "No subsidiaries created",
	sucursales_titulo: "Subsidiaries List",
	no_hay_agentes_creados: "No agents created",
	agentes_titulo: "Agents List",
	editar_empresa: "Edit company",
	habilitar: "Enable",
	habilitar_agencia: "Enable agencia",
	habilitar_cuenta: "Enable cuenta",
	habilitar_proveedor: "Enable proveedor",
	deshabilitar_agencia: "Disable agencia",
	deshabilitar_cuenta: "Disable cuenta",
	deshabilitar_proveedor: "Disable proveedor",
	esta_seguro_que_desea_eliminar_sucursal:
		"Are you sure you want to delete the subsidiary xxxxxx?",
	esta_seguro_que_desea_eliminar_agente:
		"Are you sure you want to delete the agent xxxxxx?",
	eliminar_sucursal: "Delete Subsidiary",
	eliminar_agente: "Delete Agent",
	editar_agente: "Edit Agent",
	editar_sucursal: "Edit Subsidiary",
	provincia: "Province",
	esta_seguro_que_desea_habilitar_la_empresa:
		"¿Are you sure you want to enable the company (xxxxxx)?",
	esta_seguro_que_desea_deshabilitar_la_empresa:
		"¿Are you sure you want to disable the company (xxxxxx)?",
	deshabilitar: "Disable",
	tipo_soporte_ya_existe: "The selected name already exists.",
	sin_asignar: "Unassigned",
	varios: "Various",
	item: "ITEM",
	total: "TOTAL",
	motivo: "REASON",
	asignados_total: "ASSIGNED / TOTAL",
	ubicacion_tipo_dispositivo: "LOCATION / TYPE OF DEVICE",
	la_campanna_no_tiene_dispositivos_asociados:
		"The campaign hasn't associated devices",
	asignar_motivo: "Assign reason",
	ver_motivos: "Ver reason",
	ver_mapa: "Ver mapa",
	motivos: "Reasons",
	agregar_motivo: "Add reasons",
	cant: "QTY.",
	ubicacion: "LOCATION",
	tipo_de_soporte: "TYPE OF SUPPORT",
	tipo_de_soporte_: "Type of support",
	no_encontrado_resultados: "No results found",
	valor: "Value",
	agregar: "Add",
	eliminar_elementos: "Remove items",
	seguro_desea_eliminar_los_elementos:
		"¿Are you sure you want to delete the items?",
	fecha_inicio_fin: "START DATE ~ END DATE",
	date_format_D_MMM_YYYY: "D-MMM-YYYY",
	eliminar_motivos: "Remove reasons",
	seguro_desea_eliminar_los_motivos:
		"¿Are you sure you want to remove the reasons?",
	motivo: "Reason",
	cantidad_de_elementos: "Number of elements",
	buscar_direccion_o_patente: "Search address or patent",
	periodo: "Period",
	no_hay_datos_disponibles: "No data available",
	id: "ID",
	lleva_prueba_color: "TAKE COLOR TEST",
	tipo_de_dispositivo: "Type of device",
	color: "Colour",
	agregar_editar_motivo: "ADD / EDIT REASON",
	asignacion_de_motivos: "Assignment of reasons",
	tipos_de_soporte: "Types of support",
	hora_inicio: "Start Time",
	hora_fin: "End time",
	dias: "Days",
	por_tipo_de_soporte: "BY TYPE OF SUPPORT",
	por_motivo: "BY REASON",
	filtros: "Filters",
	sin_motivo_asignado: "No Reason Assigned",
	confirmar_campana: "Confirm campaign",
	seguro_decea_confirmar_campana:
		"¿Are you sure you want to confirm the campaign? You will not be able to edit items again or assign reasons.",
	initial_of_weeksdays: ["M", "T", "W", "R", "F", "S", "U"],
	accion_eliminar: "Delete",
	seguro_que_desea_eliminar_duplicado_de_XXXX:
		"¿Are you sure you want to remove duplicate from XXXX?",
	debe_selecciona_minimo_un_dia: "You must select at least one day",
	campanna: "Campaign",
	sustrato: "Substratum",
	tecnologia: "Technology",
	fecha_de_inicio: "Start date",
	medida_final: "Final measure",
	duracion_maxima: "Maximum duration",
	formato_digital: "Digital format",
	tiene_rotacion: "Has Rotation",
	medida_visible: "Visible measurement",
	ver_dispositivo: "VIEW DEVICE",
	descargar_original: "DOWNLOAD ORIGINAL",
	descargar_archivo_en_baja: "DOWNLOAD FILE IN LOW",
	no_hay_elementos_asociados: "There are no associated elements",
	no_hay_elementos_disponibles: "No items available",
	jpg_en_baja: "Jpg in low",
	video_en_baja: "Video in low",
	arrastre_o_haga_click_aqui: "Drag or click here",
	cargar_imagen: "Haga click aquí para adjuntar imagen",
	descargar_ficha: "DOWNLOAD SHEET",
	analogico: "Analogical",
	digital: "Digital",
	link_de_descarga: "Download link",
	fecha_aprobacion_prueba_color: "Color test approval date",
	fecha_envio_imprenta: "Printing dispatch date",
	fecha_finalizacion_impresion: "Fecha finalización impresión",
	segundos: "Seconds",
	formato_de_imagen_no_valido: "Invalid image format",
	formato_de_video_no_valido: "Invalid video format",
	imprenta: "Printing",
	solo_admite_un_archivo_maximo: "Only supports one file",
	solo_admite_archivos_jpg_jpeg_bmp_png_gif_tiff:
		"Only supports files .jpg, .jpeg, .bmp, .png, .gif, .tiff",
	solo_admite_archivos_wma_mp4_avi_mov:
		"Only supports files .wma, .mp4, .avi, .mov",
	el_archivo_excede_a_10_mb_en_su_tamano: "The file exceeds 10 Mb in size",
	ha_ocurrido_un_error_al_descargar_el_archivo:
		"An error occurred while downloading the file",
	poi: "POI",
	puntos_de_interes: "Points of interest",
	observacion_medidas: "Measured observations",
	sub_categoria: "Sub category",
	disponibilidad: "Availability",
	ots: "Ots",
	date_range_picker_locale: {
		sunday: "Su",
		monday: "Mo",
		tuesday: "Tu",
		wednesday: "We",
		thursday: "Th",
		friday: "Fr",
		saturday: "Sa",
		today: "Today",
		ok: "Apply",
	},
	referencias: "References",
	no_se_han_agregado_soportes_a_la_propuesta:
		"No supports have been added to the proposal",
	editar_fechas: "Edit dates",
	ver_comentarios: "See comments",
	seleccionados: "Selected",
	medidas_comerciales_alto_x_ancho: "Trade measures (high x width):",
	eliminar_figura_seleccionada: "Delete selected figure",
	eliminar_todas_las_figuras: "Delete all shapes",
	confirma_que_desea_borrar_el_dato:
		"¿Confirm that you want to delete the data?",
	la_tarjeta_volvera_estado_correspondiente_borraran_todos_los_datos_ingresados_posteriormente:
		"The card will return to the corresponding state and all data entered later will be erased",
	se_modifico_dato_desea_guardar_mantener_tarjeta_en_estado_actual_guardar_mover_estado_correspondiente:
		"A data has been modified, do you want to save and keep the card in the current state or save and move to the corresponding state?",
	de_ser_necesario_se_borraran_los_datos_existentes_de_estados_posteriores:
		"If necessary, the existing data of later states will be deleted.",
	max: "Max",
	min: "Min",
	el_valor_minimo_no_puede_ser_vacio: "The minimum value cannot be empty",
	el_valor_maximo_no_puede_ser_vacio: "The maximum value cannot be empty",
	el_valor_minimo_no_puede_superar_al_valor_maximo:
		"The minimum value cannot exceed the maximum value",
	el_valor_minimo_no_puede_ser_menor_al_tope_minimo_existente:
		"The minimum value cannot be less than the existing minimum limit",
	el_valor_maximo_no_puede_ser_mayor_al_tope_maximo_existente:
		"The maximum value cannot be greater than the existing maximum limit",
	el_valor_minimo_no_puede_ser_mayor_al_tope_maximo_existente:
		"The minimum value cannot be greater than the existing maximum limit",
	el_valor_maximo_no_puede_ser_menor_al_tope_minimo_existente:
		"The maximum value cannot be less than the existing minimum limit",
	ocultar_todos: "Hide all",
	mostrar_todos: "Show all",
	radio: "Radio",
	guardar_mantener: "Save & Keep",
	guardar_mover: "Save & Move",
	agregar_comentario: "Add comment",
	debe_seleccionar_solo_uno_listado: "You must select only one from the list",
	el_tipo_soporte_seleccionado_listado_corresponde_este:
		"The type of media selected from the list does not correspond to this",
	enviar_propuesta: "Send proposal",
	editar_propuesta: "Edita proposal",
	liberar_propuesta: "Release proposal",
	convertir_a_campana: "Convert to campaign",
	estado_de_propuesta_actualizado: "Updated proposal status",
	error_al_actualizar_propuesta: "Error updating proposal",
	desea_dar_de_baja_esta_propuesta: "¿You want to cancel this proposal?",
	desea_convertir_esta_propuesta_a_campaña:
		"¿You want to convert this proposal to a campaign?",
	aprobacion_de_propuesta: "Proposal approval",
	ingresar_mensaje_opcional: "Enter message (Optional)",
	enviada: "Sent",
	propuesta_enviada_correctamente: "Proposal sent successfully",
	agregado: "Aggregate",
	fecha_de_vencimiento_de_propuesta: "Proposal expiration date",
	el_formato_no_es_correcto: "The format is not correct",
	este_campo_es_requerido: "This field is required",
	el_campo_no_puede_tener_mas_de_n_caracteres:
		"The field cannot have more than {###} characters.",
	la_fecha_de_vencimiento_debe_ser_posterior_o_igual_a_hoy:
		"Expiration date must be later than or equal to today.",
	quitar_elementos: "Remove items",
	el_soporte_quitar_esta_mas_propuesta_desea_quitar_todas_sus_instancias_del_listado:
		"¿The element to delete is more than once in the proposal, you want to remove all its instances from the list?",
	confirma_que_desea_quitar_dispositivo_propuesta:
		"¿Confirm that you want to remove the item from the proposal?",
	editar_seleccionados: "Edit selected",
	soportes_seleccionados: "Selected",
	debe_seleccionar_un_rango_de_fechas: "You must select a date range",
	ha_ocurrido_un_error_al_actualizar_intentelo_mas_tarde:
		"An error occurred while updating. Please try again later",
	proposal_comments: "Comments",
	proposal_old_comments: "Previous comments",
	comment_view_more: "See comment",
	comment_view_less: "Hide comment",
	el_listado_del_tipo_soporte_esta_completo:
		"The list of the type of support is complete",
	la_propuesta_contiene_al_menos_un_elemento_no_disponible:
		"The proposal contains at least one element not available",
	soportes_asignados: "Assigned element types",
	datos_de_la_propuesta: "Proposal data",
	seleccionar_soporte: "Select element type",
	direccion_o_patente: "Address or patent",
	checking_approve: "Approve",
	checking_reject: "Reject",
	soportes_no_disponibles: "Element types not available",
	revisar_disponibilidad: "Check availability",
	al_convertir_a_campana_se_descartaran_los_soportes_no_disponibles_estas_seguro:
		"When converting to a campaign, the unavailable element types will be discarded, are you sure?",
	si_descartar_no_disponibles: "Yes, discard not available",
	no_editar_propuesta: "No, edit proposal",
	checking_request_changes: "Request changes",
	checking_saved: "Saved",
	saved_changes: "Changes made successfully",
	checking_strategy_tab: "Strategy",
	checking_proposaList_tab: "List of elements in proposal",
	checking_map_tab: "Media map",
	listado_de_elementos: "List of elements",
	estrategia: "Strategy",
	escribe_aqui: "Write here...",
	descartar: "Discard",
	vista_previa: "Preview",
	No_se_admite_propuesta_sin_soportes:
		"Proposal without element types is not allowed",
	checking_modal_accept: "Accept",
	checking_modal_cancel: "Cancel",
	checking_modal_text: "Are you sure you want to approve the proposal?",
	existen_soportes_incompletos: "There are incomplete element types",
	listado_de_soportes: "List of element types",
	tipo_dispositivo_ubicacion: "Device type - Location",
	solo_puede_subir_n_archivos_simultaneos:
		"You can only upload {n} files simultaneously",
};
